import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger)

export const contact = () => {

	let tabs = document.querySelectorAll('[data-tab]'),
		panels = document.querySelectorAll('[data-panel]')

	tabs.forEach(tab => {
		tab.addEventListener('click', () => {
			let target = tab.getAttribute('data-tab')
			tabs.forEach(t => t.setAttribute('data-status', 'inactive'))
			panels.forEach(p => p.setAttribute('data-status', 'inactive'))
			tab.setAttribute('data-status', 'active')
			let activePanel = document.querySelector(`[data-panel="${target}"]`)
			if (activePanel) activePanel.setAttribute('data-status', 'active')
		})
	})
}

export default () => { }